<template>
  <CustomRow>
    <v-card class="pa-5 mt-5" :class="{ 'px-2': $vuetify.breakpoint.xs }">
      <div class="text-center text-big-title font-weight-bold mb-5">
        {{ CampaignType === "top" ? "所有熱門活動" : "即將開始活動" }}
      </div>
      <div class="px-2" v-if="loadingFinished">
        <ListActivity :campaigns="campaignsByPage"></ListActivity>
      </div>
      <div v-else class="text-center">
        <ProgressCircular />
      </div>
    </v-card>
    <v-pagination class="mt-5" v-model="page" :total-visible="$vuetify.breakpoint.xs ? 5 : undefined" :length="pageLength"
      circle color="yellow-1"></v-pagination>
  </CustomRow>
</template>

<script>
import ListActivity from "@/views/components/ListActivity.vue";
import { getEvents } from "@/api/static";
import CC from "@/api/config-center";
import { decrypt, encrypt } from '../vendor/crypto';

export default {
  components: { ListActivity },
  data() {
    return {
      page: 1,
      campaigns: [],
      CampaignType: this.$route.params.type === "top" ? "top" : "commingSoon",
      loadingFinished: false
    };
  },
  metaInfo() {
    return {
      title: `${this.CampaignType === "top" ? "所有熱門活動" : "即將開始活動"} - ${this.$t("app_name")}`,
      script: [{
        type: 'application/ld+json',
        json: {
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": `${this.$t('news_list_title')} - ${this.$t('app_name')}`,
          "url": window.location.href
        }
      }]
    }
  },
  computed: {
    campaignsByPage() {
      return this.campaigns.slice((this.page - 1) * 12, this.page * 12);
    },
    pageLength() {
      let divideList = Math.floor(this.campaigns.length / 12);
      return this.campaigns.length % 12 ? divideList + 1 : divideList;
    }
  },
  async mounted() {
    getEvents().then(async res => {
      this.campaigns = res.data.events.filter(c => {
        if (this.CampaignType === "top") return c.hot;
        else return c.comming;
      });
      let eventsId = this.campaigns.map(e => {
        return String(e.event_id);
      });
      let [resEventsInfo, getInfosErr] = await CC.getInfos({
        eventId: eventsId
      });

      resEventsInfo.data.result.event = resEventsInfo.data.result.event.map(ev => { return { ...ev, id: ev.id } })
      this.campaigns = this.campaigns.reduce((accr, event) => {
        let evt = resEventsInfo.data.result.event.find(res => res.id === event.event_id || encrypt(res.id) === event.event_id);
        accr.push({
          ...event,
          ...evt,
        });
        return accr;
      }, []);
      this.loadingFinished = true;

      this.$gtm.trackView(`${this.CampaignType === "top" ? "所有熱門活動" : "即將開始活動"}`, this.$route.path);
    });
  }
};
</script>

<style lang="scss" scoped>
::v-deep .v-pagination__item--active {
  color: $primary-1 !important;
}
</style>
